import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import AddCommentIcon from '@mui/icons-material/AddCommentOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SmsProviderList from "./SmsProviderList";
import SmsProviderCreate from "./SmsProviderCreate";

const SmsProviderManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Sms provider"
        viewIcon={<MailOutlineIcon />}
        createIcon={<AddCommentIcon />}
        createChildren={<SmsProviderCreate />}
        listChildren={<SmsProviderList />}
      />
    </Box>
  );
};

export default SmsProviderManagement;